let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6JmR4")).then(() => parcelRequire('9rynJ'));